import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { theme } from "../theme";
import RenderIf from "../components/RenderIf";
import FloatButton from "../components/ui/FloatButton";
import DashedButton from "../components/ui/DashedButton";
import Output from "./Output";
import styled from "styled-components";
import resetData from "../tools/resetData";
import { WatchContext } from "../WatchContext";
import autofillData from "../tools/autofillData";

const Styles = {
  ColoredH1: styled.h1`
    color: ${({ color }) => color};
    display: inline;
    text-align: center;
  `,
  DashOuter: styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
  `,
  ButtonCol: styled.div`
    margin: 0 2rem;
  `,
};

const Dashboard = () => {
  const navigate = useNavigate();

  const {
    horizontal,
    vertical,
    hydrology,
    biology,
    sediment,
    soil,
    water,
    permit,
    vertsed, horsed, hydrosed, biosed,
    setBiology,
    setBiosed,
    setHorizontal,
    setHorsed,
    setHydrology,
    setHydrosed,
    setPermit,
    setSediment,
    setSoil,
    setVertical,
    setVertsed,
    setWater,
  } = useContext(WatchContext);

  let {grey4, pdeBlue } = theme.colors;

  let stateArray = [
    horizontal,
    vertical,
    hydrology,
    biology,
    sediment,
    soil,
    water,
  ];

  let dashedElems = stateArray.map((metric, i) => (
    <RenderIf key={i} isTrue={metric.complete !== 100}>
      <DashedButton
        borderColor={pdeBlue}
        handleClick={() => navigate(`/${metric.type}`)}
      >
        <Styles.ColoredH1 color={pdeBlue}> + {metric.title}</Styles.ColoredH1>
      </DashedButton>
    </RenderIf>
  ));

  let solidElems = stateArray.map((metric, i) => (
    <RenderIf key={i} isTrue={metric.complete === 100}>
      <FloatButton
        handleClick={() => navigate(`/${metric.type}`)}
      >
        <Styles.ColoredH1 color={grey4}>{metric.title}</Styles.ColoredH1>
      </FloatButton>
    </RenderIf>
  ));

  let numPermits = permit.permits.filter((permit) => !!permit.selected).length;

  console.log('dashboard test', horsed)

  return (
    <Styles.DashOuter>
      <Styles.ButtonCol>
        <RenderIf isTrue={process.env.NODE_ENV === 'development'}>
        <FloatButton handleClick={() => autofillData([...stateArray, vertsed, horsed, hydrosed, biosed], [setHorizontal, setVertical,  setHydrology, setBiology,  setSediment, setSoil, setWater, setVertsed, setHorsed, setHydrosed, setBiosed])}>
          <Styles.ColoredH1 color={grey4}>Autofill</Styles.ColoredH1>
        </FloatButton>
        </RenderIf>
        <FloatButton handleClick={() => navigate(`/about`)}>
          <Styles.ColoredH1 color={grey4}>What is WATCH?</Styles.ColoredH1>
        </FloatButton>
        <FloatButton handleClick={() => navigate(`/instructions`)}>
          <Styles.ColoredH1 color={grey4}>How to enter data</Styles.ColoredH1>
        </FloatButton>
        {dashedElems}
        {solidElems}
        <RenderIf isTrue={numPermits > 0}>
          <FloatButton handleClick={() => navigate(`/regulatory`)}>
            <Styles.ColoredH1 color={grey4}>Permit Alignment</Styles.ColoredH1>
          </FloatButton>
        </RenderIf>
        <RenderIf isTrue={numPermits === 0}>
          <DashedButton
            borderColor={pdeBlue}
            handleClick={() => navigate(`/regulatory`)}
          >
            <Styles.ColoredH1 color={pdeBlue}>
              {" "}
              + Permit Alignment
            </Styles.ColoredH1>
          </DashedButton>
        </RenderIf>
        <FloatButton
          handleClick={() => resetData(
            setBiology,
            setBiosed,
            setHorizontal,
            setHorsed,
            setHydrology,
            setHydrosed,
            setPermit,
            setSediment,
            setSoil,
            setVertical,
            setVertsed,
            setWater
          )}
        >
          <Styles.ColoredH1 color={grey4}>Reset all data</Styles.ColoredH1>
        </FloatButton>
        {/* <RenderIf isTrue={process.env.REACT_APP_NJRESTORS}>
        <FloatButton handleClick={() => navigate('/')}><Styles.ColoredH1 color={grey4}>Return to NJResTORS</Styles.ColoredH1></FloatButton>
        </RenderIf> */}
      </Styles.ButtonCol>
      <Output chartData={stateArray} data={stateArray} />
    </Styles.DashOuter>
  );
};

export default Dashboard;
